import { Navigate, useParams } from 'react-router-dom';

import { authorized, authorizedLoader, isOrganizationUser } from '../../../utils/loaders.ts';
import url from '../../../utils/url.ts';
import {
    contactPersonsTabLoader,
    contactTabLoader,
    generalTabLoader,
    jobsTabLoader,
    organizationProfileDetailPageLoader,
    organizationProfileListPageLoader,
} from './loaders.ts';
import {
    ADMIN_ORGANIZATION_PROFILE_CONTACT_PATH,
    ADMIN_ORGANIZATION_PROFILE_CONTACT_PERSONS_PATH,
    ADMIN_ORGANIZATION_PROFILE_DETAIL_PATH,
    ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_ADD_PATH,
    ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_EDIT_PATH,
    ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_PATH,
    ADMIN_ORGANIZATION_PROFILE_GENERAL_PATH,
    ADMIN_ORGANIZATION_PROFILE_JOBS_PATH,
    ADMIN_ORGANIZATION_PROFILE_LIST_PATH,
} from './paths.ts';

const IndexRedirect = () => {
    const { profileId } = useParams();
    return <Navigate to={url(ADMIN_ORGANIZATION_PROFILE_GENERAL_PATH, { profileId })} replace={true} />;
};

export default [
    {
        handle: {
            title: ['admin:organizationProfileListPage.documentTitle'],
        },
        path: ADMIN_ORGANIZATION_PROFILE_LIST_PATH,
        lazy: async () => ({ Component: (await import('./pages/OrganizationProfileListPage.tsx')).default }),
        loader: authorizedLoader(organizationProfileListPageLoader, isOrganizationUser),
    },
    {
        handle: {
            title: ['admin:organizationProfileDetailPage.documentTitle'],
        },
        path: ADMIN_ORGANIZATION_PROFILE_DETAIL_PATH,
        lazy: async () => ({ Component: (await import('./pages/OrganizationProfileDetailPage.tsx')).default }),
        loader: authorizedLoader(organizationProfileDetailPageLoader, isOrganizationUser),
        children: [
            {
                handle: {
                    title: ['admin:organizationProfileDetailPage.documentTitle'],
                },
                index: true,
                element: <IndexRedirect />,
                loader: authorizedLoader(organizationProfileDetailPageLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationProfileDetailPage.generalTab.documentTitle'],
                },
                path: ADMIN_ORGANIZATION_PROFILE_GENERAL_PATH,
                lazy: async () => ({ Component: (await import('./tabs/GeneralTab.tsx')).default }),
                loader: authorizedLoader(generalTabLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationProfileDetailPage.contactTab.documentTitle'],
                },
                path: ADMIN_ORGANIZATION_PROFILE_CONTACT_PATH,
                lazy: async () => ({ Component: (await import('./tabs/ContactTab.tsx')).default }),
                loader: authorizedLoader(contactTabLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationProfileDetailPage.contactPersonsTab.documentTitle'],
                },
                path: ADMIN_ORGANIZATION_PROFILE_CONTACT_PERSONS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/ContactPersonsTab.tsx')).default }),
                loader: authorizedLoader(contactPersonsTabLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationProfileDetailPage.jobsTab.documentTitle'],
                },
                path: ADMIN_ORGANIZATION_PROFILE_JOBS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/JobsTab.tsx')).default }),
                loader: authorizedLoader(jobsTabLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationProfileDetailPage.eventSessionsTab.documentTitle'],
                },
                path: ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/EventSessionsTab.tsx')).default }),
                loader: authorized(isOrganizationUser),
                children: [
                    {
                        handle: {
                            title: ['admin:organizationProfileDetailPage.eventSessionsTab.addDocumentTitle'],
                        },
                        path: ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_ADD_PATH,
                        lazy: async () => ({
                            Component: (await import('./tabs/EventSessionsTab.tsx')).AddEventSessionFormDialog,
                        }),
                        loader: authorized(isOrganizationUser),
                    },
                    {
                        handle: {
                            title: ['admin:organizationProfileDetailPage.eventSessionsTab.editDocumentTitle'],
                        },
                        path: ADMIN_ORGANIZATION_PROFILE_EVENT_SESSIONS_EDIT_PATH,
                        lazy: async () => ({
                            Component: (await import('./tabs/EventSessionsTab.tsx')).EditEventSessionFormDialog,
                        }),
                        loader: authorized(isOrganizationUser),
                    },
                ],
            },
        ],
    },
];
